import classnames from 'classnames'
import type { PropsWithChildren, FC, ReactNode } from 'react'
import React, { forwardRef } from 'react'

import styles from './ActionsDropZone.module.css'

type ActionsDropZoneProps = {
  vertical?: boolean
}

export const ActionsDropZone: FC<PropsWithChildren<ActionsDropZoneProps>> = ({
  children,
  vertical
}) => {
  return (
    <div
      className={classnames(styles.Container, {
        [styles.VerticalContainer]: vertical
      })}
    >
      {children}
    </div>
  )
}

type ActionsDropZoneItemProps = {
  children: ReactNode
  className?: string
  highlight?: boolean
  vertical?: boolean
}

export const ActionsDropZoneItem = forwardRef<any, ActionsDropZoneItemProps>(
  ({ children, vertical, className, highlight = false }, ref) => {
    return (
      <div
        ref={ref}
        className={classnames(styles.Item, {
          [styles.Highlight]: highlight,
          [styles.HorizontalItem]: !vertical,
          [styles.VerticalItem]: vertical
        })}
      >
        <div className={className}>{children}</div>
      </div>
    )
  }
)
